import _ from 'lodash';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'value' implicitly has an 'any' type.
const toMarkObject = (value) => ({ value, label: '' });
const marksWithStepOf500 = _.range(2500, 10000, 500).map(toMarkObject);
const marksWithStepOf1000 = _.range(10000, 61000, 1000).map(toMarkObject);
const priceRangeSliderMarks = _.concat(marksWithStepOf500, marksWithStepOf1000);

export { priceRangeSliderMarks };
